<template>
  <b-form-group
    label="Açıklama"
    label-for="content"
  >

      <b-form-input
        id="content"
        v-model="dataItem.content"
        placeholder="Açıklama"
      />


  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@core/utils/validations/validations'

export default {
  name: 'Title',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['sectors/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
